import React from "react";

import {
  HYDRAULIC_TYPE_OPTIONS,
  PILLAR_TYPE_OPTIONS,
} from "../../../data";
import { boxKey, NOTE, TYPE_KEY, useQuoteBoxStructure } from "../../../hooks/useQuoteBoxStructure";
import {
  QuoteBoxStructurePatch,
  QuoteDoorCard,
  QuoteOptionItem,
} from "../../../types";
import { NoteField, NumberField, SelectField } from "./FormFields";
import { CardRow, FieldsRow, StructureCard } from "./BoxStructureFields";

const DOOR_TITLES: Record<QuoteDoorCard, string> = {
  pillars: "PILLARS",
  sideDoors: "SIDE_DOORS",
  rearDoor: "REAR_DOOR",
  hydraulicSide: "HYDRAULIC_SIDE",
};

const DoorFields = ({
  cardKey,
  item,
  patch,
}: {
  cardKey: QuoteDoorCard;
  item: QuoteOptionItem;
  patch: QuoteBoxStructurePatch;
}) => {
  if (cardKey === "pillars") {
    return (
      <FieldsRow>
        <SelectField
          labelKey={TYPE_KEY}
          value={item.selectedOption}
          options={PILLAR_TYPE_OPTIONS}
          onChange={(selectedOption) => patch(cardKey, { selectedOption })}
          grow
        />
        <NumberField
          labelKey={boxKey("FIELDS.QUANTITY")}
          value={item.quantity}
          onChange={(quantity) => patch(cardKey, { quantity })}
          narrow
        />
      </FieldsRow>
    );
  }

  if (cardKey === "sideDoors") {
    return (
      <FieldsRow>
        <NumberField
          labelKey={boxKey("FIELDS.MISSING_QUANTITY")}
          value={item.quantity}
          onChange={(quantity) => patch(cardKey, { quantity })}
          quantityStepper
        />
        <NoteField
          labelKey={NOTE}
          placeholderKey={NOTE}
          value={item.note}
          onChange={(note) => patch(cardKey, { note })}
          grow
        />
      </FieldsRow>
    );
  }

  if (cardKey === "rearDoor") {
    return (
      <NoteField
        labelKey={NOTE}
        placeholderKey={NOTE}
        value={item.note}
        onChange={(note) => patch(cardKey, { note })}
      />
    );
  }

  return (
    <SelectField
      labelKey={TYPE_KEY}
      value={item.selectedOption}
      options={HYDRAULIC_TYPE_OPTIONS}
      onChange={(selectedOption) => patch(cardKey, { selectedOption })}
    />
  );
};

export const DoorRow = ({ keys }: { keys: QuoteDoorCard[] }) => {
  const { data, patch } = useQuoteBoxStructure();

  return (
    <CardRow>
      {keys.map((cardKey) => (
        <StructureCard
          key={cardKey}
          enabled={data[cardKey].enabled}
          titleKey={boxKey(`CARDS.${DOOR_TITLES[cardKey]}`)}
          onToggle={(enabled) => patch(cardKey, { enabled })}
        >
          <DoorFields cardKey={cardKey} item={data[cardKey]} patch={patch} />
        </StructureCard>
      ))}
    </CardRow>
  );
};
